import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import user from './store/modules/usermodule'
import getters from './store/getters'
import nutricionista from './store/modules/nutricionistamodule'

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    user,
    nutricionista

  },
  getters
})

export default store
